/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_P2Inputs */

const en_privacy_section_1_p2 = /** @type {(inputs: Privacy_Section_1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Privacy Policy explains how we collect, use, store, and protect your personal data when you visit our website at lindevo.com, interact with our AI chatbot, use our contact forms, or engage with our services.`)
};

const lv_privacy_section_1_p2 = /** @type {(inputs: Privacy_Section_1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šī privātuma politika izskaidro, kā apkopojam, izmantojam, glabājam un aizsargājam Jūsu personas datus, kad apmeklējat lindevo.com, sarunājaties ar mūsu AI asistentu, izmantojat kontaktformas vai mūsu pakalpojumus.`)
};

/**
* | output |
* | --- |
* | "This Privacy Policy explains how we collect, use, store, and protect your personal data when you visit our website at lindevo.com, interact with our AI chatb..." |
*
* @param {Privacy_Section_1_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_p2 = /** @type {((inputs?: Privacy_Section_1_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_p2(inputs)
	return en_privacy_section_1_p2(inputs)
});